/* wiseXPD homepage behaviour (wx-home-*). No dependencies, loaded deferred,
   safe to include from several sections: it runs once.

   1. Hero: measures how far the hero sits from the top of the page (announcement
      bar plus header) so it fills exactly one viewport, and attaches the
      desktop clip only on desktop and never under reduced motion.
   2. Carousels ([data-wxh-carousel]): arrows scroll the native scroll-snap
      track by one slide, and an optional calm advance (data-interval seconds)
      pauses on hover, focus, touch and when off screen, and never runs under
      reduced motion. No counter. With [data-wxh-loop] the strip is infinite
      (one copy on each side, re-centred on scroll end) and a mouse can drag it. */
(function () {
  if (window.__wxhHome) return;
  window.__wxhHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: true };

  function headerHeight() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(v);
    return n > 0 && n < 240 ? n : 0;
  }

  function hero() {
    var el = document.querySelector('[data-wxh-hero]');
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.scrollY;
    if (top > 0 && top < 400) el.style.setProperty('--wxh-top', top + 'px');

    var v = el.querySelector('video[data-src]');
    if (!v || reduce || !desktop.matches) return;
    v.src = v.getAttribute('data-src');
    v.removeAttribute('data-src');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function carousel(root) {
    var track = root.querySelector('[data-wxh-track]');
    if (!track) return;
    var real = Array.prototype.slice.call(track.children);
    if (!real.length) return;
    var n = real.length;
    var loop = root.hasAttribute('data-wxh-loop') && n > 1;
    var prev = root.querySelector('[data-wxh-prev]');
    var next = root.querySelector('[data-wxh-next]');

    var hh = headerHeight();
    if (hh) root.style.setProperty('--wxh-head', hh + 'px');

    /* Loop: one full copy of the strip on each side. Copies are hidden from
       assistive tech and out of the tab order; the real set sits in the middle. */
    function copy(s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-wxh-clone', '');
      c.removeAttribute('data-shopify-editor-block');
      Array.prototype.forEach.call(c.querySelectorAll('a, button, [tabindex]'), function (e) { e.setAttribute('tabindex', '-1'); });
      return c;
    }
    if (loop) {
      var head = document.createDocumentFragment(), tail = document.createDocumentFragment();
      real.forEach(function (s) { head.appendChild(copy(s)); tail.appendChild(copy(s)); });
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
    }
    var slides = Array.prototype.slice.call(track.children);
    var base = loop ? n : 0;

    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function pos(el) { return el.offsetLeft - pad(); }
    function span() { return pos(slides[base + n]) - pos(slides[base]); }
    function current() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var e = Math.abs(pos(slides[k]) - x);
        if (e < d) { d = e; best = k; }
      }
      return best;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function update() {
      if (loop) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = atEnd();
    }
    /* Back into the real set, by exactly one strip, without animation. */
    function settle() {
      /* The drift wraps itself; re-centring under it as well made the strip
         jump back and forth by a whole set (Lau: "it kinda resets"). */
      if (!loop || dragging || track.classList.contains('is-drifting')) return;
      var s = span(), x = track.scrollLeft, start = pos(slides[base]);
      if (s <= 0) return;
      if (x < start - 2) track.scrollLeft = x + s;
      else if (x >= start + s - 2) track.scrollLeft = x - s;
    }
    function go(dir) {
      var i = current() + dir;
      if (i < 0) i = 0;
      if (i >= slides.length) i = slides.length - 1;
      track.scrollTo({ left: pos(slides[i]), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (loop) {
      track.scrollLeft = pos(slides[base]);
      /* Both snap the strip to a slide edge, which a drifting strip must never
         do: the load event lands seconds in, once every image and film is in,
         and showed as the strip jumping back mid-glide (Lau: "it kinda resets"). */
      window.addEventListener('load', function () {
        if (track.classList.contains('has-drift')) return;
        if (track.scrollLeft < pos(slides[base]) - 2) track.scrollLeft = pos(slides[base]);
      });
      var rz;
      window.addEventListener('resize', function () {
        if (track.classList.contains('has-drift')) return;
        clearTimeout(rz);
        rz = setTimeout(function () { var i = current() % n; track.scrollLeft = pos(slides[base + i]); }, 120);
      });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); stop(true); });
    if (next) next.addEventListener('click', function () { go(1); stop(true); });
    var t;
    var hasEnd = 'onscrollend' in window;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { update(); if (!hasEnd) settle(); }, hasEnd ? 60 : 160);
    }, { passive: true });
    if (hasEnd) track.addEventListener('scrollend', settle);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); stop(true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); stop(true); }
    });
    update();

    /* Mouse drag (touch and trackpads scroll natively). A drag never clicks
       through to a card link. */
    var dragging = null, swallow = false;
    if (loop) {
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = { x: e.clientX, left: track.scrollLeft, moved: false };
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragging.x;
        if (!dragging.moved && Math.abs(dx) > 5) { dragging.moved = true; track.classList.add('is-drag'); stop(true); }
        if (dragging.moved) track.scrollLeft = dragging.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        var moved = dragging.moved;
        dragging = null;
        if (!moved) return;
        swallow = true;
        setTimeout(function () { swallow = false; }, 0);
        var i = current();
        track.classList.remove('is-drag');
        track.scrollTo({ left: pos(slides[i]), behavior: reduce ? 'auto' : 'smooth' });
      });
      track.addEventListener('click', function (e) { if (swallow) { e.preventDefault(); e.stopPropagation(); swallow = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* Drift ([data-wxh-drift] = pixels per second, loop only): a slow,
       continuous scroll that stops only while the visitor is moving the strip
       themselves (drag, touch, wheel or trackpad, arrows, keyboard) and carries
       on from wherever they leave it as soon as that scroll settles. Hover does
       not stop it (Lau, 6 Oct). Never under reduced motion, never off screen or
       in a hidden tab. Snap is off while it drifts, or the browser would pull
       it back to a slide edge. */
    var drift = loop ? parseFloat(root.getAttribute('data-wxh-drift') || '0') : 0;
    var SETTLE = 450; /* ms after the visitor's last scroll movement */
    if (drift > 0 && !reduce) {
      var dVisible = false, touching = false, busyUntil = 0, acc = 0, prevT = 0, mine = -1;
      /* No snapping on a drifting strip: each pause would pull it back to a slide edge. */
      track.classList.add('has-drift');
      function hold(ms) { busyUntil = Math.max(busyUntil, Date.now() + ms); track.classList.remove('is-drifting'); }
      /* Only a sideways gesture is the visitor moving the strip. Scrolling the
         page up or down with the pointer over it must not stop it. */
      track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey) hold(SETTLE);
      }, { passive: true });
      track.addEventListener('keydown', function () { hold(900); });
      track.addEventListener('touchstart', function () { touching = true; hold(SETTLE); }, { passive: true });
      track.addEventListener('touchend', function () { touching = false; hold(SETTLE); }, { passive: true });
      track.addEventListener('touchcancel', function () { touching = false; hold(SETTLE); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { hold(900); });
      if (next) next.addEventListener('click', function () { hold(900); });
      /* Momentum and smooth scrolls keep firing scroll events after the input
         ends; any scroll we did not make ourselves keeps the hold alive. */
      track.addEventListener('scroll', function () {
        if (Math.abs(track.scrollLeft - mine) > 1.5) hold(SETTLE);
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { dVisible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
      } else { dVisible = true; }
      function frame(t) {
        var dt = prevT ? Math.min(t - prevT, 64) : 0;
        prevT = t;
        var idle = !touching && !dragging && Date.now() >= busyUntil;
        if (idle && dVisible && !document.hidden) {
          if (!track.classList.contains('is-drifting')) {
            track.classList.add('is-drifting');
            acc = track.scrollLeft;
            /* Start from inside the middle set, so every wrap is one exact set. */
            var s0 = span(), st0 = pos(slides[base]);
            if (s0 > 0) { while (acc < st0) acc += s0; while (acc >= st0 + s0) acc -= s0; }
          }
          acc += drift * dt / 1000;
          var s = span(), start = pos(slides[base]);
          if (s > 0) { if (acc >= start + s) acc -= s; else if (acc < start) acc += s; }
          track.scrollLeft = acc;
          mine = track.scrollLeft;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    var secs = drift > 0 ? 0 : parseInt(root.getAttribute('data-interval') || '0', 10);
    var timer = null, paused = false, visible = false, stopped = false;
    function stop(forever) { if (forever) stopped = true; clearInterval(timer); timer = null; }
    function start() {
      if (reduce || stopped || !secs || timer) return;
      timer = setInterval(function () {
        if (paused || !visible || document.hidden || dragging) return;
        if (!loop && atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' }); else go(1);
      }, secs * 1000);
    }
    if (secs && !reduce) {
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { stop(true); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.35 }).observe(root);
      } else { visible = true; }
      start();
    }
  }

  function init() {
    hero();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wxh-carousel]'), carousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
